module.exports = {"152224100":"突泉镇","152224101":"六户镇","152224102":"东杜尔基镇","152224103":"永安镇","152224104":"水泉镇","152224105":"宝石镇","152224200":"学田乡","152224201":"九龙乡","152224202":"太平乡","152224400":"东杜尔基国营农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152224.json
// module id = 482
// module chunks = 0